import React from 'react'
import { Outlet } from 'react-router-dom'
// import { CssBaseline, Toolbar } from '@mui/material'
// import { Box } from '@mui/system'

const Profile = () => <Outlet/>


export default Profile